import { z } from 'zod';
import { learnerProfileSchema } from './learner.js';
/**
 * The sign-up placement questionnaire. Answers are single-choice; the recommendation is a
 * pure function of them (see `placement.ts`), and the learner may adjust the chosen path.
 * Modules stay optional and openable whatever the path says.
 */
export const placementAnswersSchema = z.object({
    coding: z.enum(['none', 'some', 'professional']),
    webApp: z.enum(['no', 'parts', 'endToEnd']),
    frontend: z.enum(['none', 'some', 'confident']),
    llm: z.enum(['no', 'basic', 'validated']),
    agents: z.enum(['no', 'prototypes', 'shipped']),
    goal: z.enum(['foundations', 'fullStack', 'aiFeatures', 'agents']),
});
const moduleNumberSchema = z.number().int().positive();
export const placementRationaleSchema = z.object({
    module: moduleNumberSchema,
    title: z.string(),
    recommended: z.boolean(),
    reason: z.string(),
});
export const placementRecommendationSchema = z.object({
    startModule: moduleNumberSchema,
    modules: z.array(moduleNumberSchema).min(1),
    rationale: z.array(placementRationaleSchema),
    summary: z.string(),
});
/** The path the learner follows: the recommendation as saved, or their own adjustment of it. */
export const learnerPathSchema = z.object({
    startModule: moduleNumberSchema,
    modules: z.array(moduleNumberSchema).min(1),
    source: z.enum(['recommended', 'adjusted']),
});
export const learnerPlacementSchema = z.object({
    questionnaireVersion: z.number().int().positive(),
    answers: placementAnswersSchema,
    recommendation: placementRecommendationSchema,
    path: learnerPathSchema,
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
export const submitPlacementSchema = z.object({
    questionnaireVersion: z.number().int().positive(),
    answers: placementAnswersSchema,
    /** Omitted: the recommendation is saved as the path. */
    chosenStartModule: moduleNumberSchema.optional(),
    chosenModules: z.array(moduleNumberSchema).min(1).max(12).optional(),
});
export const placementStateSchema = z.object({
    questionnaireVersion: z.number().int().positive(),
    placement: learnerPlacementSchema.nullable(),
});
export const placementSaveResponseSchema = z.object({
    placement: learnerPlacementSchema,
    learner: learnerProfileSchema,
});
export const placementSkipResponseSchema = z.object({ learner: learnerProfileSchema });
